"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Gor.Hakobyan on 01-Mar-18.
 */
var Helper = /** @class */ (function () {
    function Helper() {
    }
    Helper.getFrequencyNameById = function (frequency) {
        if (!frequency) {
            return null;
        }
        switch (frequency) {
            case (1):
                return 'Once';
            case (2):
                return 'Year';
            case (3):
                return 'SemiAnnual';
            case (4):
                return 'Quarter';
            case (5):
                return 'Month';
            case (6):
                return 'Week';
            case (7):
                return 'Day';
            default:
                throw Error('Mistake frequency id');
        }
    };
    return Helper;
}());
exports.Helper = Helper;
//# sourceMappingURL=helper.util.js.map